import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import Navbar from "../Navbar/Navbar_00";
//import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Footer from "../Footer/Footer_00";

// import './Forms.css';

import Swal from 'sweetalert2'

import Loader from '../../../loader';

import * as Hosts from '../../../Hosts';

import {
    set_language,
    reqGET,
    reqPOST,
    //repo_banner_link,
    passwordHash,
    gerarPassword,
    content_language,
    pattern_email,
    pattern_vat,
    functionSendMail

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import { language } from '../WEBContent/Language';

const RegisterClientForm = (props) => {    
  
  const [, set_dados] = useState(null);
  const colaboradores_list = useRef(null);

  const [refresh, setRefresh] = useState(0);

  const is_logged_in = useRef(null);
  
  const [dados_config, set_dados_config] = useState({});
  const [dados_navbar, set_dados_navbar] = useState({});

  const [isloading, setLoading] = useState(true);
  const [isRedirect, setRedirect] = useState(false)

  const [lang, set_lang] = useState('pt');
  const [lang_id, set_lang_id] = useState('1');

  const [pwd, set_pwd] = useState('');

  const data_interface = {
    id: '',
    info: {
        companycode: Hosts.companycode,
        username: '',
        password: '',
        name: '',
        surname: '',
        birthday: '',
        email: '',
        vat: '',
        rgpd: false,
        ativo: false,
        terms: false,
        entity_type: '',
        observation: '',
        identificacao: {
            tipo_identificacao:	'',
            numero_identificacao:	'',
            validade_identificacao:	''
        },
        use_preferences: {
            language: 'PT'
        }
    },
    addresses: [{
        //village: '',
        //city: '',
        //type: [],
        //region: '',
        country: '',
        //apartado: '',
        location: '',
        place_birth: '',
        village: '',
        municipality: '',
        //contats: [],
        //principal: '',
        //observation: '',
        postal_code: '',
        address: '',
        //address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',

        principal: 'true',
        //extensions: [],
        observation: '',

        //building_number: '',
        /*person_responsables: [{
            id: '',
            name: '',
            email: '',
            extensions: '',
            observation: '',
            mobile_phone: ''
        }],*/
    }],
    profile: { name: "Cliente" },
    notifications: []
  }

  const dados = useRef(data_interface);

    useEffect(() => {

        set_dados(colaboradores_list.current = [])
        set_pwd(gerarPassword());

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }
        
        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)
    
            if(token_info !== undefined && token_info !== null) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }
    
            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }
    
            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }
            
            let res_c = await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Colaborador`)
            if(res_c.data.length > 0) {
                set_dados(colaboradores_list.current = res_c.data)
            }
    
            setLoading(false)
        })()

    }, [props]);

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
        // if agree === true, it will be set to false
        // if agree === false, it will be set to true
        setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const check_entity_field = async (name, value) => {
      await reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/*`)
        .then(res => {

          let ja_existe = false
          res.data.forEach((k) => {
            //console.log(res.data)
            if (k[name] === value) {
              ja_existe = true
            }
          })

          if (ja_existe === false) {

            return

          } 
          else {
            set_dados(dados.current.info['username'] = '');
            set_dados(dados.current.info['email'] = '');
            setRefresh(refresh + 1)
            //console.log('aki aki');
            Swal.fire({
                title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
                text: language[lang].username_error_message,
                icon: 'error',
                //showCancelButton: true,
                confirmButtonColor: 'var(--primary) !important',
                //confirmButtonText: 'Tentar novamente',
              })

          }
        }
        )
	  }

    const handle_change_info = (e) => {
      const { name, value } = e.target;

      set_dados(dados.current.info[name] = value)

      if ((name === 'email') && value !== '') {
        check_entity_field('username', value)
        set_dados(dados.current.info['username'] = value)
        set_dados(dados.current.contacts[0]['email'] = value)
      }

      //console.log('«««««««««««««««««««««««')
      //console.log('Dados Current info 2:' + JSON.stringify(dados))
    }

    const handle_change_info_2 = (e) => {
      const { name, value } = e.target;

      set_dados(dados.current.info[name] = value)

      //console.log('«««««««««««««««««««««««')
      //console.log('Dados Current info 2:' + JSON.stringify(dados))
    }

    const handle_change_contacts = (e) => {
      const { name, value } = e.target;

      set_dados(dados.current.contacts[0][name] = value)

      console.log('«««««««««««««««««««««««')
      console.log('Dados Current info 2:' + JSON.stringify(dados))
    }

    const handleSubmit = async e => {
        e.preventDefault();

        Swal.fire('Loading...')

        dados.current.info.password = passwordHash(pwd);
        dados.current.info.terms = agree;

        reqPOST(`${Hosts.SIMCore_API}/entities`, dados.current)
            .then(async (res) => {   

                if(res.status === 200) {

                let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + ';border:1px solid transparent;border-collapse:collapse;">' +
                                        '<tr style="border-collapse: collapse;">' +
                                            '<td align="left" class style="padding:40px; border-collapse:collapse;">' +
                                                '<div>'+
                                                '<h4 style="margin-top:0; text-transform: uppercase;">'+ language[lang].client_regist +'</h4>'+
                                                '<span><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                                                '<br/>'+
                                                '<span><b>'+ language[lang].email +': </b><label>' + dados.current.info.email + '</label></span>'+
                                                '<br/>'+
                                                '<span><b>'+ language[lang].nif +': </b><label>' + dados.current.info.vat + '</label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<h4 style="margin-top:0; text-transform: uppercase;">'+ language[lang].access_data +'</h4>'+
                                                '<span><b>'+ language[lang].username +': </b><label>' + dados.current.info.username + '</label></span>'+
                                                '<br/>'+
                                                '<span><b>'+ language[lang].password +': </b></label>'+ pwd +'</label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app +'</a>'+
                                                '<br/>'+
                                                '</div>'+
                                            '</td>' +
                                        '</tr>' +
                                    '</table>'

                await functionSendMail(Hosts.contactFrom, [dados.current.info.email], [], Hosts.webSiteTitle + ' - ' + language[lang].new_regist, mail_content, [], dados_config)

                let today = new Date();
                let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                let mail_content_2 =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                    '<tr style="border-collapse: collapse;">' +
                        '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>' +
                                '<span><b>' + language[lang].client_regist + '</b></span>' +
                            '</div>' +
                        '</td>' + 
                        '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>'+ today_aux + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr>' +
                        '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>' + language[lang].user_regist_email_sent + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:0px 40px;border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +
                
                    '<tr>' +
                        '<td colspan="2" align="right" style="height: 15px;"></td>' +
                    '</tr>' +
                '</table>'

                let sendFrom = Hosts.contactFrom
                let sendTo = [Hosts.contactFrom]
                let sendToCC = ['web.dev@assec.pt']
                let subject = Hosts.webSiteTitle + ' - ' + language[lang].new_regist
                let content = mail_content_2
                let attachment = []

                colaboradores_list.current.forEach(el_cl => {
                    if(el_cl.contacts[0].email !== '') {
                        sendToCC.push(el_cl.contacts[0].email)
                    }
                })

                await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)

                Swal.fire({
                    icon: "info",
                    title: "",
                    text: language[lang].regist_form_sucess_message,
                    showConfirmButton: false,
                    timer: 200
                });

                setTimeout(() => {                        
                    setRedirect(true)
                }, 200)

                //alert('Registo efetuado com sucesso!\n\nConsulte os seus dados de acesso no email enviado.')
                // set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                // document.getElementById('agree').checked = false 
                //props.history.push(endpoints.list) 


                /*
                reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
                    .then(() => { 
                        console.log('Notificações enviadas com sucesso')
                    })
                    .catch((error) => console.log(error))
                */

                }
                else {
                Swal.fire({
                    title: '',
                    text: language[lang].username_error_message,
                    icon: 'error',
                    //showCancelButton: true,
                    confirmButtonColor: 'var(--primary) !important',
                    //confirmButtonText: 'Tentar novamente',
                })
                }
            })
            .catch((error) => console.log(error) /*alert('Problema ao atualizar Registo!')*/)
    }

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
            isloading ?
                <Loader />
            :

                <>
                    <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                    <main id="client_regist">
                        <div className='container-fluid'>
                            <div className="row">
                                <div className='col-12 bg-light py-5'>
                                    <div className='container'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3 className="titulo-primario">
                                                    {language[lang].new_regist}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="container my-5">
                                <div className="row">
                                    <div className='col-12 col-lg-10 mx-auto'>
                                        <div className='row'>
                                            <div className="col-12 mb-3">
                                                {language[lang].read_terms_conditions}
                                            </div>
                                            <div className="col-12 mb-3">
                                                <h4 className='subtitulo-primario'>{language[lang].personal_data}</h4>
                                            </div>
                                            <div className="col-12 mb-3">
                                                <label className="form-label" htmlFor='name'>{language[lang].name} *</label>
                                                <input 
                                                    id="name"
                                                    type="text"
                                                    name="name"
                                                    value={dados.current.info.name}
                                                    className="form-control"
                                                    placeholder={language[lang].name_placeholder}
                                                    onChange={handle_change_info}
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-6 col-md-4 mb-3">
                                                <label className="form-label" htmlFor='email'>{language[lang].email} *</label>
                                                <input 
                                                    id="email"
                                                    type="email" 
                                                    pattern={pattern_email}
                                                    name="email"
                                                    value={dados.current.info.email}
                                                    className="form-control"
                                                    placeholder={language[lang].email_placeholder}
                                                    //onChange={handle_change_info}
                                                    onBlur={handle_change_info}
                                                    onChange={handle_change_info_2}
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-6 col-md-4 mb-3">
                                                <label className="form-label" htmlFor='phone'>{language[lang].phone_number} *</label>
                                                <input 
                                                    id="phone"
                                                    type="text"
                                                    name="phone"
                                                    value={dados.current.contacts[0].phone}
                                                    className="form-control"
                                                    placeholder={language[lang].phone_number_placeholder}
                                                    onChange={handle_change_contacts}
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-6 col-md-4 mb-3">
                                                <label className="form-label" htmlFor='vat'>NIF *</label>
                                                <input
                                                    id="vat"
                                                    type="text"
                                                    name="vat"
                                                    minLength="9"
                                                    inputMode='numeric'
                                                    value={dados.current.info.vat}
                                                    pattern={pattern_vat}
                                                    className="form-control"
                                                    placeholder={language[lang].nif_placeholder}
                                                    onChange={handle_change_info}
                                                    required
                                                />
                                            </div>
                                            <div className="col-12">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)} />
                                                    <label className="form-check-label small" htmlFor="agree">{language[lang].agree_terms_conditions}</label>&nbsp; 
                                                    {
                                                        dados_config.content !== undefined && dados_config.content !== null &&
                                                        dados_config.content[0] !== undefined && dados_config.content[0] !== null &&
                                                        dados_config.content[0].terms !== undefined && dados_config.content[0].terms !== null &&
                                                        dados_config.content[0].terms[lang_id] !== undefined && dados_config.content[0].terms[lang_id] !== null &&
                                                        dados_config.content[0].terms[lang_id].link !== undefined && dados_config.content[0].terms[lang_id].link !== null && dados_config.content[0].terms[lang_id].link !== '' ?
                                                            <a className="small" href={dados_config.content[0]?.terms[lang_id]?.link} target="_blank" rel="noreferrer">
                                                                {language[lang].terms_conditions_link}
                                                            </a>
                                                        :
                                                            <a className="small pe-none" href='!#' target="_blank" rel="noreferrer">
                                                                {language[lang].terms_conditions_link}
                                                            </a>
                                                    }
                                                </div>
                                                <div className="mt-2 small">{language[lang].terms_conditions_required}</div>
                                            </div>
                                            <div className="col-12 text-end mt-4">
                                                <a href={Hosts.EMAIL_WEB_SITE_URL} className="btn btn-secondary me-3"> {language[lang].back} </a>
                                                <button disabled={!agree} className="btn btn-primary"> {language[lang].send} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </main>
                    <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                </>
    );


}

export default RegisterClientForm;